import i18n from '../../../i18n';
import { BankCardView } from './Card';
import { BankShell } from './Shell';
import { currencyLabel, dash, readDetailItem } from './shared';
import './bank.css';

export const BankAccountDetail = () => {
  const item = readDetailItem();
  if (!item) {
    return (
      <BankShell title={i18n.BankAccount.Title}>
        <div class="empty">{i18n.BankList.LoadFail}</div>
      </BankShell>
    );
  }

  const rows = [
    { label: i18n.BankAccount.AccountNo, value: dash(item.bankAccountNum) },
    { label: i18n.BankAccount.BankCode, value: dash(item.bankCode) },
    { label: i18n.BankAccount.AccountType, value: currencyLabel(item.currency) || '-' },
    { label: i18n.BankAccount.HolderName, value: dash(item.bankAccountName) },
  ];

  return (
    <BankShell title={i18n.BankAccount.Title}>
      <div class="detail">
        <BankCardView item={item} />
        <div class="table">
          {rows.map((row) => (
            <div class="table-row">
              <div class="table-label">{row.label}</div>
              <div class="table-value">{row.value}</div>
            </div>
          ))}
        </div>
      </div>
    </BankShell>
  );
};
